module.exports = __webpack_public_path__ + "static/img/Isaac-Kako.4ce2ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac-Kako.jpg
// module id = laP/
// module chunks = 0